"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("@/common/Api"));
const Event_1 = __importDefault(require("@/common/Event"));
const types = __importStar(require("@/store/mutation-types"));
const decimal_js_1 = __importDefault(require("decimal.js"));
const _ = __importStar(require("lodash"));
const binance_1 = require("../../util/binance");
const vue_1 = __importDefault(require("vue"));
const state = {
    feeInformationCoin: [],
    market: {},
    coin: {},
    ticker: {},
    marketId: null,
    worldCurrency: [],
    currentBaseCoin: "BTC",
};
const getters = {
    coin: (state) => _.get(state, ["coin"], {}),
    marketsByCode: (state) => {
        return _.chain(state)
            .get(["market"], [])
            .keyBy("code")
            .value();
    },
    marketLists: (state) => {
        return _.chain(state)
            .get(["market"], [])
            .value();
    },
    feeInformationCoin: (state) => _.get(state, ["feeInformationCoin"], {}),
    coinSettings: (state) => _.chain(state)
        .get(["coin"], {})
        .omit("KRW")
        .filter((coin) => {
        return coin.enable === "Y";
    })
        .keyBy("code")
        .value(),
    currencySettings: (state) => _.chain(state)
        .get(["coin"], {})
        .filter((coin) => {
        return coin.enable === "Y";
    })
        .keyBy("code")
        .value(),
    marketsByBaseCoinCode: (state, getters) => {
        return _.chain(state)
            .get(["market"], [])
            .groupBy("baseCoinCode")
            .value();
    },
    getCoinSetting(state) {
        return (coinCode) => _.get(state, ["coin", coinCode], {});
    },
    getCoinById(state, getters) {
        return (coinId) => _.find(getters.currencySettings, { id: coinId });
    },
    getCoinId(state) {
        return (coinCode) => _.get(state, ["coin", coinCode, "id"], "");
    },
    coinIdMap(state) {
        return _.keyBy(_.map(state.coin, (coin) => coin), "id");
    },
    marketCodeMap(state) {
        return _.keyBy(state.market, (market) => _.get(market, ["code"]));
    },
    marketsByBaseCoin(state) {
        return _.groupBy(state.market, "baseCoinCode");
    },
    marketsByDealCoin(state) {
        return _.groupBy(state.market, "dealCoinCode");
    },
    marketWithCoin(state) {
        return (marketId) => {
            const market = _.get(state, ["market", marketId], {});
            const baseCoinInfo = _.get(state, ["coin", market.baseCoinCode]);
            const dealCoinInfo = _.get(state, ["coin", market.dealCoinCode]);
            return Object.assign(Object.assign({}, market), { baseCoinInfo,
                dealCoinInfo });
        };
    },
    actMarket: (state, getters) => {
        return getters.marketWithCoin(state.marketId);
    },
    worldCurrency: (state) => _.get(state, ["worldCurrency"], []),
    worldCurrencyByCoinCode: (state, getters) => {
        return _.chain(getters.worldCurrency)
            .filter((c) => c.cidxCode !== "KRW")
            .groupBy("cidxCode")
            .value();
    },
    worldCurrencyByCoinCodeKRW: (state, getters) => {
        return _.chain(getters.worldCurrency)
            .filter((coin) => coin.ciCode === "KRW")
            .groupBy("cidxCode")
            .value();
    },
    worldCurrencyByCoinCodeBTC: (state, getters) => {
        return _.chain(getters.worldCurrency)
            .filter((c) => c.cidxCode !== "KRW")
            .filter((c) => c.ciCode == "BTC")
            .groupBy("cidxCode")
            .value();
    },
    toKRW: (state, getters) => {
        return (coinCode) => {
            const KRWmarket = getters.marketsByCode[`KRW-${coinCode}`] || {};
            const USDTmarket = getters.marketsByCode[`USDT-${coinCode}`] || {};
            const BTCmarket = getters.marketsByCode[`BTC-${coinCode}`] || {};
            const KRWticker = _.get(state, ["market", KRWmarket.id], {});
            const USDTticker = _.get(state, ["market", USDTmarket.id], {});
            const BTCticker = _.get(state, ["market", BTCmarket.id], {});
            const returnPrice = {
                price: 0,
                isShow: false,
            };
            if (USDTticker.close) {
                console.log("usdtTicker-----------");
                const KRWmarketUSDT = getters.marketsByCode[`KRW-USDT`];
                console.log("KRWmarketUSDT-----------", KRWmarketUSDT);
                const KRWUSDTmarketUSDTPrice = _.get(state, ["market", KRWmarketUSDT && KRWmarketUSDT.id], {});
                console.log("KRWUSDTmarketUSDTPrice-----------", KRWUSDTmarketUSDTPrice);
                returnPrice.price = KRWUSDTmarketUSDTPrice.close * USDTticker.close;
                returnPrice.isShow = true;
            }
            else if (KRWticker.close) {
                console.log("krwTicker---------");
                if (coinCode == "USDT") {
                    console.log("coinCodeUSDT---------");
                    returnPrice.price = KRWticker.close;
                    returnPrice.isShow = true;
                }
            }
            console.log("elseeeee----");
            return returnPrice;
        };
    },
    dealToKRW: (state, getters) => {
        return (coinCode, baseCoinCode = "KRW") => {
            try {
                const market = getters.marketCodeMap[`${baseCoinCode}-${coinCode}`];
                const baseCoinPrice = getters.toKRW(baseCoinCode).price;
                const currentPrice = getters.ticker[market.id].close;
                return new decimal_js_1.default(baseCoinPrice).mul(currentPrice).toNumber();
            }
            catch (e) {
                return 0;
            }
        };
    },
    totalAssetToKRW: (state, getters) => {
        const wallets = getters.wallet;
        let total = new decimal_js_1.default(0);
        for (let k in wallets) {
            try {
                if (wallets[k].coinId === 1) {
                    total = total.add(wallets[k].total);
                }
                else {
                    const coinCode = _.get(getters, ["coinIdMap", k, "code"]);
                    var value = isNaN(new decimal_js_1.default(getters.toKRW((0, binance_1.bnCode)(coinCode)).price)
                        .mul(wallets[k].total)
                        .toNumber())
                        ? 0
                        : new decimal_js_1.default(getters.toKRW((0, binance_1.bnCode)(coinCode)).price)
                            .mul(wallets[k].total)
                            .toNumber();
                    total = total.add(value);
                }
            }
            catch (e) {
                console.log(e);
            }
        }
        return total.floor().toNumber();
    },
    totalAvailToKRW: (state, getters) => {
        const wallets = getters.wallet;
        let total = new decimal_js_1.default(0);
        for (let k in wallets) {
            try {
                if (wallets[k].coinId === 1) {
                    total = total.add(wallets[k].available);
                }
                else {
                    const coinCode = _.get(getters, ["coinIdMap", k, "code"]);
                    var value = isNaN(new decimal_js_1.default(getters.toKRW(coinCode).price)
                        .mul(wallets[k].available)
                        .toNumber())
                        ? 0
                        : new decimal_js_1.default(getters.toKRW(coinCode).price)
                            .mul(wallets[k].available)
                            .toNumber();
                    total = total.add(value);
                }
            }
            catch (e) {
                console.log(e);
            }
        }
        return total.floor().toNumber();
    },
    ticker: (state) => _.get(state, ["ticker"], {}),
    sliceVolume: (state) => (volume, minTrade) => {
        if (volume == 0)
            return 0;
        let range = 0;
        if (Number(minTrade) >= 1) {
            range = `${minTrade}`.length - 1;
        }
        else {
            range = `${minTrade}`.length - 2;
        }
        volume = volume * Math.pow(10, range);
        volume = volume.toFixed(8);
        volume = Math.floor(volume);
        volume = volume / Math.pow(10, range);
        return volume;
    },
};
const actions = {
    setMarketByCode({ getters, dispatch }, marketCode) {
        if (!getters.marketCodeMap[marketCode]) {
            return location.assign("/");
        }
        const marketId = getters.marketCodeMap[marketCode].id;
        return dispatch("setMarket", marketId);
    },
    setMarket({ commit, getters, dispatch }, marketId) {
        commit(types.CHANGE_MARKET, marketId);
        return Promise.all([
            dispatch("updateLastTrade", marketId),
        ])
            .then(() => {
            if (getters.isLogin) {
                return Promise.all([
                    dispatch("updateConcluded", { marketId }),
                    dispatch("updatePend", { marketId }),
                ]);
            }
            return Promise.resolve([]);
        })
            .then(() => {
            return commit(types.CHANGE_MARKET, marketId);
        });
    },
    getCoinSetting({ commit }) {
    },
    updateAllMarketsLastTrade({ state, getters, commit }) {
        return Promise.all(_.map(getters.marketsByCode, ({ id }) => {
            return Api_1.default.Trade.getLastTrade(id, {
                completed: "Y",
                count: 10,
                page: 1,
            }).then((_res) => {
                const data = _.map(_res.body, (trade) => (Object.assign({}, trade)));
                commit(types.UPDATE_LAST_TRADE, { marketId: id, data });
            });
        }));
    },
    updateLastTrade({ state, commit }, marketId) {
        return Api_1.default.Trade.getLastTrade(marketId, {
            completed: "Y",
            count: 15,
            page: 1,
        }).then((_res) => {
            const data = _.map(_res.body, (trade) => (Object.assign({}, trade)));
            commit(types.UPDATE_LAST_TRADE, { marketId, data });
        });
    },
    updateWorldCurrency({ commit }) {
        return Api_1.default.Chart.getWorldCurrency().then((response) => {
            commit(types.UPDATE_WORLD_CURRENCY, response.body.length ? response.body : false);
        });
    },
};
const mutations = {
    [types.CHANGE_MARKET](state, marketId) {
        state.marketId = marketId;
    },
    [types.UPDATE_COIN_SETTING](state, { coinCode, data = [], }) {
        data = data.map((coinInfo) => {
            if (coinInfo.name) {
                const tmp = coinInfo.name.split("");
                if (tmp[tmp.length - 2] == "_" &&
                    (tmp[tmp.length - 1] == "B" || tmp[tmp.length - 1] == "U")) {
                    coinInfo.name = coinInfo.name.slice(0, coinInfo.name.length - 2);
                }
                else {
                }
                return coinInfo;
            }
        });
        const feeInformationCoin = data.reduce((acc, crr) => {
            const formData = [];
            const exceptionCoin = ["SFP", "SCRT", "RLC"];
            if (exceptionCoin.find((coin) => coin === crr.code)) {
                return acc.concat(formData);
            }
            if (crr.subCoins) {
                crr.subCoins.forEach((coin) => {
                    formData.push({
                        code: `${crr.code}(${coin.title})`,
                        outFee: coin.outFee,
                        minOut: crr.minOut,
                        inFee: "무료",
                    });
                });
            }
            else {
                formData.push({
                    code: crr.code,
                    outFee: crr.outFee,
                    minOut: crr.minOut,
                    inFee: "무료",
                });
            }
            return acc.concat(formData);
        }, []);
        state.feeInformationCoin = feeInformationCoin;
        if (coinCode) {
            state.coin[coinCode] = Object.assign(Object.assign({}, _.get(state.coin, [coinCode], {})), data);
        }
        else {
            const coinSettings = _.keyBy(data, "code");
            _.forEach(coinSettings, (coinSetting, index) => {
                state.coin[index] = Object.assign(Object.assign({}, _.get(state.coin, index, {})), coinSetting);
            });
        }
        return data;
    },
    [types.UPDATE_MARKETS](state, data = []) {
        const newData = _.keyBy(data, (market) => market.id);
        let marketObj = {};
        for (let k in newData) {
            marketObj[k] = Object.assign(Object.assign({}, _.get(state, ["market", k], {})), newData[k]);
        }
        state.market = marketObj;
    },
    [types.UPDATE_ORDERBOOK](state, data) {
        for (let k in data) {
            state.market[k] = Object.assign(Object.assign({}, _.get(state, ["market", k], {})), data[k]);
        }
        Event_1.default.$emit("orderbookUpdate", null);
    },
    [types.UPDATE_ORDERBOOK_SINGLE](state, { id, data }) {
        state.market[id] = Object.assign(Object.assign({}, state.market[id]), { data });
        Event_1.default.$emit("orderbookUpdate", null);
    },
    [types.UPDATE_ALL_TICKER](state, tickers) {
        tickers.map((ticker) => {
        });
    },
    [types.UPDATE_TICKER](state, { marketId, data }) {
    },
    [types.UPDATE_CURRENT](state, currentList) {
        for (let [id, { price, volume }] of Object.entries(currentList)) {
            const tick = _.get(state, ["ticker", id], {});
            const low = _.min([state.market[id].low, price]);
            const high = _.max([state.market[id].high, price]);
            const close = price;
            const sumVolume = new decimal_js_1.default(state.market[id].volume || 0)
                .add(volume)
                .toNumber();
            const sumAmount = +new decimal_js_1.default(state.market[id].acc_amount || 0).add(new decimal_js_1.default(price).mul(volume));
            const data = Object.assign(Object.assign({}, tick), { volume: sumVolume, acc_amount: sumAmount, low,
                high,
                close });
            Event_1.default.$emit("currentPriceUpdate", id);
        }
    },
    [types.UPDATE_LAST_TRADE](state, { marketId, data }) {
        const lowercaseData = data.map((now) => {
            return {
                price: now.price || now.PRICE,
                amount: now.amount || now.AMOUNT,
                type: now.type || now.TYPE,
            };
        });
        state.market[marketId] = Object.assign(Object.assign({}, _.get(state, ["market", marketId], {})), { lastTrade: lowercaseData });
    },
    [types.UPDATE_LAST_TRADE_ROW](state, { MKIDX, event, PRICE, QTY }) {
        if (getters.marketLists[MKIDX].lastTrade) {
            console.log("market.ts-----");
            getters.marketLists[MKIDX].lastTrade = _.take([
                { event, amount: QTY, PRICE },
                ...(state.market[MKIDX].lastTrade || {}),
            ], 10);
        }
        else {
            console.log("market.ts--else-----");
            getters.marketLists[MKIDX].lastTrade = [{ event, amount: QTY, PRICE }];
        }
    },
    ["TRADE_LOG_ARRAY"](state, tradeList) {
        for (let [id, list] of Object.entries(tradeList)) {
            let newList = [];
            if (state.market[id].lastTrade) {
                newList = list.concat(state.market[id].lastTrade || []);
            }
            else {
                newList = list;
            }
            state.market[id].lastTrade = _.take(newList, 15);
        }
    },
    [types.UPDATE_WORLD_CURRENCY](state, data) {
        state.worldCurrency = data;
    },
    UPDATE_REBASE_STATUS(state, _data) {
        for (var item of _data) {
            const { id, baseCoinId, onTradeEnable, enable } = item;
            const target = _.chain(state)
                .get("market")
                .find((market) => market.id === id && market.baseCoinId === baseCoinId)
                .value();
            vue_1.default.set(target, "onTradeEnable", onTradeEnable);
            vue_1.default.set(target, "enable", enable);
        }
    },
    UPDATE_CURRENT_BASE_COIN(state, data) {
        state.currentBaseCoin = data;
    },
    SET_UPDATE_SOCKET_TICKER(state, data) {
        state.ticker[data.MKIDX] = Object.assign(Object.assign({}, state.ticker[data.MKIDX]), { close: data.price });
    },
};
exports.default = {
    state,
    getters,
    actions,
    mutations,
};
